import React, { Fragment, useEffect, useRef, useState } from "react";
import Breadcrumb from "../../../../layout/breadcrumb";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import salesOrderReducer from "./../../store";
import withReducer from "../../../../store/withReducer";
import PreLoader from "../../../../share-components/ui/preLoader";
import AsyncSelect from "react-select/async";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  mapSearchCustomerAutoSuggestion,
  mapSearchPaymentMethodAutoSuggestion,
  mapSearchCurrencyAutoSuggestion,
  mapSearchSalesPersonAutoSuggestion,
  mapSearchExternalSalesPersonAutoSuggestion,
} from "../../../../utils/mapper";
import { customerAutoSuggestionApi } from "../../../../services/order";

import OrderCustomerAddress from "./content/orderCustomerAddress";
import {
  getCountryList,
  getCountryListData,
  setSearchProductDialog,
} from "../../store/draftOrderSlice";
import SearchProductModal from "../../draft-order/form/content/searchProductModal";
import SaleOrderProductJqx from "./content/saleOrderProductJqx";
import ButtonLoader from "../../../../share-components/ui/buttonLoader";
import OrderDiscount from "../../draft-order/form/content/orderDiscount";
import OrderShipment from "../../draft-order/form/content/orderShipment";
import OrderTax from "../../draft-order/form/content/orderTax";
import SaleOrderPayment from "./content/saleOrderPayment";
import SalesOrderDuty from "./content/salesOrderDuty";
import { orderCommodities } from "../setting/calculation";
import {
  addSalesOrders,
  editSaleOrder,
  getExchangeRate,
  updateSalesOrder,
} from "../../store/salesOrderSlice";
import { useHistory, useParams } from "react-router-dom";
import { getCurrencyAutoSuggestionApi, checkCustomerPoNoApi } from "../../../../services/manage-order/saleOrderService";
import LogActivity from "../../../log";
import { getPaymentAutoSuggestionApi } from "../../../../services/manage-order/setting/paymentMethodService";
import { staffAutoSuggestionApi } from "../../../../services/manage-user/staffService";
import { fetchExternalSalesPersons } from "../../../manage-user/store/staffSlice";
import ReactDatePicker from "react-datepicker";
import moment from "moment";

const defaultValues = {
  id: "",
  ordered_products: [],
  currency: { value: 150, label: "USD", symbol: "$" },
  customer_po_no: "",
  memo: "",
  discount: "",
  shipping: "",
  currency_rate: 1,
  duty: "",
  tax: "",
  is_tax: false,
  customer: "",
  sales_person: "",
  special_notes: "",
  shopify_draft_order_id: "",
  shippingAddress: "",
  billingAddress: "",
  total_price: 0,
  payment_method: "",
  po_created: null,
  department_number: "",
};

yup.addMethod(yup.array, "LocationRequired", function (errorMessage) {
  return this.test(`test-card-length`, errorMessage, function (value) {
    const { path, createError } = this;
    let isValid = true;
    let message = "";
    value.map((item, index) => {
      const totalQuantity = item.inventory_location.reduce(
        (sum, product) => sum + product.quantity,
        0
      );
      if (totalQuantity != item.quantity) {
        isValid = false;
        message += item.sku + ",";
      }
    });

    message = message.substring(0, message.length - 1);

    return (
      isValid || createError({ path, message: message + " " + errorMessage })
    );
  });
});

yup.addMethod(yup.mixed, "addressRequired", function (errorMessage) {
  return this.test(`test-card-length`, errorMessage, function (value) {
    const { path, createError } = this;
    let isValid = false;

    if (
      value.address1 &&
      value.city &&
      value.phone &&
      value.province &&
      value.first_name &&
      value.city
    ) {
      isValid = true;
    }

    return isValid || createError({ path, message: errorMessage });
  });
});

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: 50,
    border: "none",
  }),
};

const dataMenu = [
  {
    type: 1,
    text: "Sales Order",
    link: "/order/sale",
  },
  {
    type: 0,
    text: "Form",
  },
];

export const schema = yup.object().shape({
  customer: yup
    .object()
    .shape({ value: yup.string() })
    .nullable()
    .required("You must select a customer."),
  customer_po_no: yup
    .string()
    .required("Customer PO No is required."),
  department_number: yup
    .string()
    .required("Department Number is required."),
  shippingAddress: yup.object().addressRequired("you must fill all details"),
  billingAddress: yup.object().addressRequired("you must fill all details"),
  ordered_products: yup
    .array()
    .LocationRequired("location Miss match with quantity"),
});

const SalesOrderForm = (props) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  let history = useHistory();
  const [loading, isSetLoading] = useState(true);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [isProductValueChange, setIsProductValueChange] = useState(true);
  const [currencyChange, setCurrencyChange] = useState(false);
  const [isTax, setIsTax] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [selectedSalesPersonId, setSelectedSalesPersonId] = useState(null);
  const [externalSalesPersonData, setExternalSalesPersonData] = useState([]);

  let searchProductRef = useRef();
  let poTimer = useRef(null);
  const hasInvalidPrice = useRef(false);
  const draftOrderState = useSelector(({ order }) => order.draftOrder);
  const {
    handleSubmit,
    formState,
    reset,
    control,
    register,
    setValue,
    setError,
    clearErrors,
    trigger,
    getValues,
    watch,
  } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });
  const { errors, isDirty } = formState;
  const watchedCustomer = watch("customer");
  const salesOrderState = useSelector(({ order }) => order.salesOrder);
  const externalSalesPersons = useSelector(
    (state) => state.staff.externalSalesPersons
  );

  useEffect(
    function () {
      if (id) {
        dispatch(editSaleOrder({ id: id })).then((res) => {
          reset(res.payload);
          onChangeDialog(true);
          isSetLoading(false);
          setShowSearch(true);
        });
      } else {
        isSetLoading(false);
      }
    },
    [id]
  );

  const typePromiseOption = (inputValue) =>
    new Promise((resolve) => {
      const data = {
        value: inputValue,
      };
      setTimeout(() => {
        resolve(
          mapSearchCustomerAutoSuggestion(customerAutoSuggestionApi(data))
        );
      });
    });

  const staffTypePromiseOption = (inputValue) => {
    const data = { value: inputValue };

    return staffAutoSuggestionApi(data)
      .then((response) => {
        return mapSearchSalesPersonAutoSuggestion(response);
      })
      .catch((error) => {
        console.error("Error fetching staff data: ", error);
        return [];
      });
  };

  const loadExternalSalesPersons = (internalSalesPerson) => {
    if (internalSalesPerson) {
      dispatch(fetchExternalSalesPersons(internalSalesPerson.value)).then(
        (result) => {
          if (result.meta.requestStatus === "fulfilled") {
            setExternalSalesPersonData(
              result.payload.map((person) => ({
                label: person.name,
                value: person.id,
              }))
            );
          }
        }
      );
    } else {
      setExternalSalesPersonData([]);
    }
  };

  useEffect(() => {
    const salesPerson = getValues("sales_person");
    if (salesPerson) {
      loadExternalSalesPersons(salesPerson);
    }
  }, [getValues("sales_person")]);

  const handleInternalSalesPersonChange = (salesPerson) => {
    setValue("sales_person", salesPerson);
    trigger("sales_person");

    setValue("external_sales_person", null);
    setExternalSalesPersonData([]);
    trigger("external_sales_person");

    loadExternalSalesPersons(salesPerson);
  };

  const currencyTypePromiseOption = (inputValue) =>
    new Promise((resolve) => {
      const data = {
        value: inputValue,
      };
      setTimeout(() => {
        resolve(
          mapSearchCurrencyAutoSuggestion(getCurrencyAutoSuggestionApi(data))
        );
      });
    });

  const paymentTypePromiseOption = (inputValue) =>
    new Promise((resolve) => {
      const data = {
        value: inputValue,
      };
      setTimeout(() => {
        resolve(
          mapSearchPaymentMethodAutoSuggestion(
            getPaymentAutoSuggestionApi(data)
          )
        );
      });
    });

  const openSearchProductDialog = () => {
    const obj = {
      props: { isOpen: true },
      data: { searchValue: searchProductRef.current.value },
    };
    dispatch(setSearchProductDialog(obj));
  };

  const onChangeDialog = (isTrigger) => {
    trigger("ordered_products");

    if (isTrigger) {
      setIsProductValueChange(!isProductValueChange);
    }
  };

  const handleCustomerPoNoDuplicateCheck = (value) => {
    clearTimeout(poTimer.current);

    if (!value) return;

    poTimer.current = setTimeout(() => {
      const params = { value };
      if (id) params.exclude_id = id;
      checkCustomerPoNoApi(params).then((res) => {
        if (res?.response?.is_duplicate) {
          setError("customer_po_no", {
            type: "manual",
            message: "This Customer PO No already exists.",
          });
        } else {
          clearErrors("customer_po_no");
        }
      });
    }, 500);
  };

  const onSubmit = (data) => {
    if (hasInvalidPrice.current) {
      setError("ordered_products", { type: "manual", message: "Rate should be greater than 0" });
      return;
    }
    setButtonDisable(true);

    let line_items = [];

    data.ordered_products.map((item, index) => {
      line_items.push({
        id: item.id,
        variant_id: item.variant,
        quantity: item.quantity,
        back_order_quantity: item.back_order_quantity,
        price: item.price,
        product_id: item.product_id,
        sub_total_price: item.total_price,
        tax_price: item.tax_amount,
        gross_price: item.gross_amount,
        is_tax: item.is_tax,
        discount: item.discount,
        item_discount: item.item_discount,
        is_percentage: getValues("is_percentage"),
        inventory_location: item.inventory_location,
      });
    });
    data.ordered_products = line_items;
    data.customer = data.customer.value;
    data.currency = data.currency.value;
    data.payment_method_id = data.payment_method?.value;
    data.sales_person_id = data.sales_person?.value;
    data.external_sales_person_id = data.external_sales_person?.value;
    if (data.po_created) {
      data.po_created = moment(data.po_created).format("YYYY-MM-DD");
    }

    if (data.id) {
      dispatch(updateSalesOrder({ ...data })).then((res) => {
        if (!res.error) {
          setButtonDisable(false);
          history.push("/order/sale");
        }
      });
    } else {
      dispatch(addSalesOrders({ ...data })).then((res) => {
        if (!res.error) {
          setButtonDisable(false);
          history.push("/order/sale");
        }
      });
    }
  };

  const handleCurrencyChange = (data) => {
    const paramsData = { currency: data.label };
    dispatch(getExchangeRate(paramsData)).then((res) => {
      setValue("currency_rate", res.payload);
      setCurrencyChange(res.payload);
    });
  };
  useEffect(() => {
    dispatch(getCountryList()).then((res) => {
      dispatch(getCountryListData(res.payload));
    });
  }, [dispatch]);

  return (
    <Fragment>
      <Breadcrumb title="Sales Order" data={dataMenu} />
      <Container fluid={true} className="product-wrapper">
        {loading ? (
          <>
            <PreLoader></PreLoader>
          </>
        ) : (
          <>
            <Row>
              {id && (
                <div
                  style={{
                    position: "fixed",
                    top: "50%",
                    zIndex: 10,
                    right: 0,
                  }}
                >
                  <LogActivity log="Sales Order" id={id}></LogActivity>
                </div>
              )}
              <Col md={9}>
                <Form
                  className="needs-validation"
                  noValidate=""
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <Card>
                    <CardBody>
                      <div className="form-row ">
                        <Col md="3">
                          <FormGroup>
                            <Label className="col-form-label">Customer</Label>

                            <AsyncSelect
                              className={` ${
                                errors.customer ? "is-invalid" : ""
                              }`}
                              isClearable
                              cacheOptions
                              defaultOptions
                              defaultValue={getValues("customer")}
                              loadOptions={typePromiseOption}
                              onChange={(e) => {
                                setValue("customer", e);
                                trigger("customer");
                                setIsTax(e.id + "-" + e.is_vat);
                              }}
                            />
                            <div className="invalid-feedback">
                              {errors.customer?.message}
                            </div>
                          </FormGroup>
                        </Col>

                        <Col md="3">
                          <FormGroup>
                            <Label className="col-form-label">
                              Customer PO <span className="text-danger">*</span>
                            </Label>
                            <input
                              type="text"
                              {...register("customer_po_no", {
                                onChange: (e) => handleCustomerPoNoDuplicateCheck(e.target.value),
                              })}
                              className={`form-control ${errors.customer_po_no ? "is-invalid" : ""}`}
                            />
                            <div className="invalid-feedback">
                              {errors.customer_po_no?.message}
                            </div>
                          </FormGroup>
                        </Col>

                        <Col md="3">
                          <FormGroup>
                            <Label className="col-form-label">Currency</Label>
                            <AsyncSelect
                              className={` ${
                                errors.customer ? "is-invalid" : ""
                              }`}
                              isClearable
                              cacheOptions
                              defaultOptions
                              defaultValue={getValues("currency")}
                              loadOptions={currencyTypePromiseOption}
                              onChange={(e) => {
                                setValue("currency", e);
                                handleCurrencyChange(e);
                              }}
                            />
                            <div className="invalid-feedback">
                              {errors.currency?.message}
                            </div>
                          </FormGroup>
                        </Col>

                        <Col md="3">
                          <FormGroup>
                            <Label className="col-form-label">
                              Payment Method
                            </Label>
                            <AsyncSelect
                              className={` ${
                                errors.customer ? "is-invalid" : ""
                              }`}
                              isClearable
                              cacheOptions
                              defaultOptions
                              defaultValue={getValues("payment_method")}
                              loadOptions={paymentTypePromiseOption}
                              onChange={(e) => {
                                setValue("payment_method", e);
                                trigger("payment_method");
                              }}
                            />
                            <div className="invalid-feedback">
                              {errors.currency?.message}
                            </div>
                          </FormGroup>
                        </Col>

                        <Col md="3">
                          <FormGroup>
                            <Label className="col-form-label">
                              Sales Person
                            </Label>

                            <AsyncSelect
                              className={` ${
                                errors.sales_person ? "is-invalid" : ""
                              }`}
                              isClearable
                              cacheOptions
                              defaultOptions
                              defaultValue={getValues("sales_person")}
                              loadOptions={staffTypePromiseOption}
                              onChange={handleInternalSalesPersonChange}
                            />

                            <div className="invalid-feedback">
                              {errors.sales_person?.message}
                            </div>
                          </FormGroup>
                        </Col>

                        <Col md="3">
                          <FormGroup>
                            <Label className="col-form-label">
                              External Sales Person
                            </Label>

                            <Select
                              getOptionLabel={(option) => option.label}
                              value={getValues("external_sales_person")}
                              getOptionValue={(option) => option.value}
                              onChange={(e) => {
                                setValue("external_sales_person", e);
                                trigger("external_sales_person");
                              }}
                              className={` ${
                                errors.external_sales_person ? "is-invalid" : ""
                              }`}
                              options={externalSalesPersonData}
                              isDisabled={externalSalesPersonData.length === 0}
                            />

                            <div className="invalid-feedback">
                              {errors.external_sales_person?.message}
                            </div>
                          </FormGroup>
                        </Col>

                        <Col md={3}>
                          <FormGroup>
                            <Label className="col-form-label">
                              Cancellation Date
                            </Label>
                            <ReactDatePicker
                              name="dispatchDate"
                              className="form-control"
                              selected={
                                getValues("cancellation_date")
                                  ? new Date(getValues("cancellation_date"))
                                  : null
                              }
                              onChange={(date) => {
                                setValue("cancellation_date", date);
                                trigger("cancellation_date");
                              }}
                              placeholderText="Select a cancellation date"
                              minDate={moment().toDate()}
                              style={{ minHeight: "auto" }}
                              dateFormat="MM/dd/yyyy"
                            />
                            <div style={{ color: "red" }}>
                              {errors.cancellation_date?.message}
                            </div>
                          </FormGroup>
                        </Col>

                        <Col md={3}>
                          <FormGroup>
                            <Label className="col-form-label">
                              PO Created
                            </Label>
                            <ReactDatePicker
                              name="po_created"
                              className="form-control"
                              selected={
                                getValues("po_created")
                                  ? new Date(getValues("po_created"))
                                  : null
                              }
                              onChange={(date) => {
                                setValue("po_created", date);
                                trigger("po_created");
                              }}
                              placeholderText="Select PO created date"
                              style={{ minHeight: "auto" }}
                              dateFormat="MM/dd/yyyy"
                            />
                          </FormGroup>
                        </Col>

                        <Col md="3">
                          <FormGroup>
                            <Label className="col-form-label">
                              Department Number <span className="text-danger">*</span>
                            </Label>
                            <input
                              type="text"
                              {...register("department_number")}
                              className={`form-control ${errors.department_number ? "is-invalid" : ""}`}
                              placeholder="Enter Department Number"
                            />
                            <div className="invalid-feedback">
                              {errors.department_number?.message}
                            </div>
                          </FormGroup>
                        </Col>
                      </div>
                    </CardBody>
                  </Card>

                  <Card>
                    <CardBody>
                      <Row>
                        <Col md="10 input-with-icon pr-1">
                          <div>
                            <FormGroup className="m-0">
                              <i className="fa fa-search"></i>
                              <input
                                name="searchProduct"
                                type="text"
                                placeholder="Search Products"
                                ref={(ref) => {
                                  searchProductRef.current = ref;
                                }}
                                onKeyUp={openSearchProductDialog}
                                className={`form-control`}
                              />
                            </FormGroup>
                          </div>
                        </Col>
                        <Col md="2 pl-0">
                          <Button
                            color="primary"
                            type="button"
                            className="btn btn-sm btn-primary btn-block"
                            onClick={openSearchProductDialog}
                            style={{ height: 38 }}
                          >
                            Browse
                          </Button>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={12}>
                          {getValues("ordered_products").length > 0 && (
                            <SaleOrderProductJqx
                              setValue={setValue}
                              getValues={getValues}
                              trigger={trigger}
                              id={id}
                              onChangeDialog={onChangeDialog}
                              isTax={isTax}
                              isProductValueChange={isProductValueChange}
                              currencyChange={currencyChange}
                              hasInvalidPrice={hasInvalidPrice}
                            />
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <div
                            style={{
                              color: "red",
                              float: "right",
                            }}
                          >
                            {errors.ordered_products?.message}
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                  {getValues("ordered_products").length > 0 && (
                    <Row>
                      <Col sm="12">
                        <SaleOrderPayment
                          setValue={setValue}
                          getValues={getValues}
                          trigger={trigger}
                          currency={getValues("currency").symbol}
                        ></SaleOrderPayment>
                        <div
                          style={{
                            color: "red",
                            float: "right",
                          }}
                        >
                          {errors.shipping?.message}
                        </div>
                      </Col>
                    </Row>
                  )}

                  {getValues("ordered_products").length > 0 && (
                    <Card>
                      <CardBody>
                        <div
                          className="float-right"
                          style={{ display: "flex" }}
                        >
                          <ButtonLoader
                            disabled={buttonDisable}
                            color="primary"
                            value="1"
                            type="submit"
                            btntext="Save"
                          ></ButtonLoader>
                        </div>
                      </CardBody>
                    </Card>
                  )}
                </Form>
              </Col>
              <Col md={3}>
                {watchedCustomer && (
                  <OrderCustomerAddress
                    id={id}
                    getValues={getValues}
                    setValue={setValue}
                    salesOrderState={salesOrderState}
                    draftOrderState={draftOrderState}
                    customer={watchedCustomer}
                    addressError={{
                      shipping: errors.shippingAddress,
                      billing: errors.billingAddress,
                    }}
                  />
                )}
                {getValues("ordered_products").length > 0 && (
                  <Card>
                    <CardBody>
                      <h6 className="mb-3">Commodity Information</h6>
                      {/* eslint-disable-next-line no-undef */}
                      {orderCommodities(
                        getValues("ordered_products"),
                        getValues("currency").symbol
                      ).map((item, i) => (
                        <p key={i}>
                          {item.commodity} {item.quantity} Cost {item.amount}
                        </p>
                      ))}
                    </CardBody>
                  </Card>
                )}
                <Card>
                  <CardBody>
                    <h6 className="mb-3">Memo</h6>
                    <textarea
                      {...register("memo")}
                      className="form-control"
                      rows={3}
                    ></textarea>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </>
        )}
      </Container>
      <SearchProductModal
        setValue={setValue}
        getValues={getValues}
        trigger={trigger}
        onChangeDialog={onChangeDialog}
        isProductValueChange={isProductValueChange}
        isAllowOutOfStock
      ></SearchProductModal>
      <OrderDiscount
        orderSetValue={setValue}
        orderTrigger={trigger}
        orderGetValues={getValues}
      ></OrderDiscount>
      <OrderShipment
        draftOrderState={draftOrderState}
        orderSetValue={setValue}
        orderTrigger={trigger}
        orderGetValues={getValues}
      ></OrderShipment>
      <OrderTax
        orderSetValue={setValue}
        orderTrigger={trigger}
        orderGetValues={getValues}
      ></OrderTax>
      <SalesOrderDuty
        orderSetValue={setValue}
        orderTrigger={trigger}
        orderGetValues={getValues}
      ></SalesOrderDuty>
    </Fragment>
  );
};

export default withReducer([{ salesOrder: salesOrderReducer }])(SalesOrderForm);
